import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 20 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 7\" id=\"icon-slider--left\"><path d=\"M4.676 6.552a19.89 19.89 0 0 0-.812-1.568 8.763 8.763 0 0 0-.812-1.12h16.324V2.688H3.052c.261-.317.532-.7.812-1.148.261-.448.532-.961.812-1.54h-.98C2.52 1.363 1.288 2.37 0 3.024v.504c1.288.635 2.52 1.643 3.696 3.024h.98Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol